/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Col_VpInputs */



/**
* | output |
* | --- |
* | "VP" |
*
* @param {User_Detail_Col_VpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_col_vp = /** @type {((inputs?: User_Detail_Col_VpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Col_VpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("VP")
	if (locale === "es") return /** @type {LocalizedString} */ ("VP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("VP")
	if (locale === "it") return /** @type {LocalizedString} */ ("VP")
	return /** @type {LocalizedString} */ ("VP")
});